<style lang="scss" src="./main.scss"></style>
<template>
  <div class="web-page">
    <WebHeader />
    <div class="web-container" v-report.pv="{f_module:'主页面'}">
      <RedeemContainer />
    </div>
    <WebFooter />
  </div>
</template>

<script>
import RedeemContainer from 'src/components/redeem-container.vue';
import WebFooter from 'src/components/web-footer.vue';
import WebHeader from 'src/components/web-header.vue';

export default {
  name: 'web-app',
  data() {
    return {
    };
  },
  components: {
    WebHeader,
    RedeemContainer,
    WebFooter,
  },
};
</script>

<style lang="scss" scoped>
.web-page {
  background: #000 !important;
}
.web-container {
  margin: 0 150px 40px 150px;
  background: rgba(255, 255, 255, .1);
  min-height: auto;
  padding: 60px 0;
  border-radius: 4px;
  min-width: 464px;
}
.web-container::v-deep .redeem-container {
  width: 464px;
  margin: 0 auto;
}

</style>
